module.exports = __webpack_public_path__ + "static/img/r3.01df6947.png";